import { Box, Paper, Stack, Typography } from '@mui/material'

import style from './style'

type Props = {
  title: string
  withLightBackground?: boolean
  imgSrc: string
  secondaryImgSrc?: string
  children: React.ReactNode
  reverseContent?: boolean
}

const Section = ({
  title,
  withLightBackground,
  imgSrc,
  secondaryImgSrc,
  reverseContent,
  children,
}: Props) => {
  return (
    <Paper elevation={0} sx={style.section({ withLightBackground, reverseContent })}>
      <Box sx={style.imgContainer}>
        <Box component="img" src={imgSrc} sx={style.img({ reverseContent })} />
        {secondaryImgSrc && (
          <Box sx={style.secondaryImgContainer({ reverseContent })}>
            <Box component="img" src={secondaryImgSrc} sx={style.secondaryImg} />
          </Box>
        )}
      </Box>
      <Stack direction="column" gap={3} maxWidth={445}>
        <Typography variant="h4" fontSize={32} color="secondary">
          {title}
        </Typography>
        {children}
      </Stack>
    </Paper>
  )
}

export default Section
